import {
  ApiSuccess,
  ApiTagTypes,
  PromptTemplate,
  PromptTemplatesSelectMode,
  PromptTemplateStatus,
  ProspectCategory,
  ProspectType,
} from '../../types';
import { apiSlice } from '../api.services';

type GetPromptTemplatesParams = {
  selectMode: PromptTemplatesSelectMode;
  type?: ProspectType;
  category?: ProspectCategory;
  status?: PromptTemplateStatus;
};

type GetPromptTemplatesResponse = ApiSuccess<{
  promptTemplates: PromptTemplate[];
}>;

type GetPromptTemplateByIdResponse = ApiSuccess<{
  promptTemplate: PromptTemplate;
}>;

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPromptTemplates: builder.query<PromptTemplate[], GetPromptTemplatesParams>({
      query: (params) => ({
        url: '/prompt-templates',
        params,
      }),
      transformResponse: (response: GetPromptTemplatesResponse) => response.data.promptTemplates,
      providesTags: [ApiTagTypes.PROMPT_TEMPLATES],
    }),
    getPromptTemplateById: builder.query<PromptTemplate, string>({
      query: (id) => ({
        url: `/prompt-templates/${id}`,
      }),
      transformResponse: (response: GetPromptTemplateByIdResponse) => response.data.promptTemplate,
      providesTags: (_, __, id) => [{ type: ApiTagTypes.PROMPT_TEMPLATES, id }],
    }),
  }),
});

export const { useGetPromptTemplatesQuery, useGetPromptTemplateByIdQuery } = enhancedApiSlice;
